import {PrimeIcons} from "primereact/api";
import {Tooltip} from "primereact/tooltip";

import {SnapshotType} from "@reva/shared/valuation-data";

import {useRevaTranslation} from "../../hooks/languageHooks";
import {selectIsSnapshot, selectSnapshotMetadata} from "../../redux/persistenceSlice";
import {useRevaSelector} from "../../redux/revaHooks";
import {formatDate, formatDateAndTime} from "../../util/dateUtil";

/**
 * Sub-Header Element - type and date of the loaded snapshot.
 * Rendered only while a frozen snapshot is loaded; nothing is shown for live valuations.
 */
export default function SnapshotElement() {
    const {t, language} = useRevaTranslation();
    const isSnapshot = useRevaSelector(selectIsSnapshot);
    const snapshotMetadata = useRevaSelector(selectSnapshotMetadata);

    if (!isSnapshot || !snapshotMetadata) return null;

    const isFinal = snapshotMetadata.type === SnapshotType.Final;
    const icon = isFinal ? PrimeIcons.LOCK : PrimeIcons.FLAG;
    const date = formatDate(snapshotMetadata.date, language);
    const label = t(isFinal ? "header.snapshotInfo.final" : "header.snapshotInfo.preFinal", {date});

    const author = snapshotMetadata.userFullName ?? snapshotMetadata.user;
    const dateTime = formatDateAndTime(snapshotMetadata.date, language);

    return (
        <>
            <span id="header-snapshot-element">
                <span className={`${icon} mr-2`} />
                {label}
            </span>
            <Tooltip target="#header-snapshot-element">
                <div>
                    <strong>{t("header.snapshotInfo.author")}</strong> {author}
                </div>
                <div>
                    <strong>{t("header.snapshotInfo.createdAt")}</strong> {dateTime}
                </div>
            </Tooltip>
        </>
    );
}
